#include ../includes/ambientLight.glsl
#include ../includes/directionalLight.glsl

uniform float uTime;
uniform vec3 uColor;
uniform vec2 uResolution;

varying vec3 vNormal;
varying vec3 vPosition;

// Lumière Directionnelle
uniform vec3 uDirectionalLightColor;
uniform float uDirectionalLightIntensity;
uniform vec3 uDirectionalLightDirection;
uniform float uDirectionalLightSpecular;

// Paramètres Halftone (Ombre)
uniform float uShadowRepetitions;
uniform vec3 uShadowColor;
uniform vec3 uShadowDirection;
uniform float uShadowLow;
uniform float uShadowHigh;

// Paramètres Halftone (Lumière)
uniform float uLightRepetitions;
uniform vec3 uLightColor;
uniform vec3 uLightDirection;
uniform float uLightLow;
uniform float uLightHigh;

vec3 halftone(
    vec3 color,
    float repetitions,
    vec3 direction,
    float low,
    float high,
    vec3 pointColor,
    vec3 normal
) {
    // Intensité
    float intensity = dot(normal, direction);
    intensity = smoothstep(low, high, intensity);

    vec2 uv = gl_FragCoord.xy / uResolution.y;
    uv *= repetitions;
    uv += vec2(uTime * -0.00001, uTime * -0.000075); // Micro-animation du grain
    uv = mod(uv, 1.0);

    // Cercle : La taille du point dépend de l'intensité calculée plus haut
    float point = distance(uv, vec2(0.5));
    point = 1.0 - step(0.5 * intensity, point);

    return mix(color, pointColor, point);
}

void main() {
    vec3 viewDirection = normalize(vPosition - cameraPosition);
    vec3 normal = normalize(vNormal);
    vec3 color = uColor;
    
    // Lumière ambiante + Directionnelle
    vec3 light = vec3(0.0);
    light += ambientLight(vec3(1.0), 1.0);
    light += directionalLight(
        uDirectionalLightColor,
        uDirectionalLightIntensity,
        normal,
        uDirectionalLightDirection,
        viewDirection,
        uDirectionalLightSpecular
    );
    color *= light;

    // Pour les ombres
    color = halftone(
        color,
        uShadowRepetitions,
        uShadowDirection,
        uShadowLow,
        uShadowHigh,
        uShadowColor,
        normal
    );
    
    // Pour la lumière (Highlight)
    color = halftone(
        color,
        uLightRepetitions,
        uLightDirection,
        uLightLow,
        uLightHigh,
        uLightColor,
        normal
    );

    gl_FragColor = vec4(color, 1.0);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}